import React, { useState } from "react";
import Slider from "react-slick";

import {
  Root,
  Container,
  Slide,
  SlideBody,
  Image,
  Action,
  Label,
} from "./Recipes.style";

import SectionTitle from "../../../components/SectionTitle/SectionTitle";
import SliderStyled from "../../../components/SliderStyled/SliderStyled";

import { RecipesModal } from "./RecipesModal";

import { slides, sliderSettings } from "./config";

export const Recipes = () => {
  const [slide, setSlide] = useState(false);

  return (
    <Root>
      <SectionTitle title="Cocktail recipes" subtitle="Shine Responsibly®" />

      <Container>
        <SliderStyled>
          <Slider {...sliderSettings}>
            {slides.map((slide, idx) => (
              <Slide
                key={slide.id}
                onClick={() => {
                  console.info({ idx: idx });
                  setSlide(idx);
                }}
              >
                <SlideBody>
                  <Label>{slide.label}</Label>
                  <Action>See Recipe</Action>
                </SlideBody>
                <Image
                  src={slide.imageSrc}
                  alt={`Image of the ‘${slide.label}’ cocktail`}
                />
              </Slide>
            ))}
          </Slider>
        </SliderStyled>
      </Container>

      {slide !== false && (
        <RecipesModal initialSlide={slide} onClose={() => setSlide(false)} />
      )}
    </Root>
  );
};
